export default function(
  num: undefined | null | number,
  fixPosition = 2
): string {
  if (!num) {
    return "-";
  }
  return num.toFixed(fixPosition);
}
